import TrabuIcon from './TrabuIcon';

export default TrabuIcon;
